/*
 * CircuitList Messages
 *
 * This contains all the text for the CircuitList component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.containers.CircuitList.title',
    defaultMessage: 'Circuit Management',
  },
  name: {
    id: 'app.containers.CircuitList.name',
    defaultMessage: 'Circuit Name',
  },
  noCircuitsYet: {
    id: 'app.containers.CircuitList.noCircuitsYet',
    defaultMessage: 'There are no circuits, yet',
  },
});
